import moment from "moment";
import {
  AddToCart,
  CreateOrder,
  DeleteItemFromCart,
  GetCart,
  GetOrder,
  GetOrders,
  OrderAddComments,
  OrderHistory,
  OrderRepeat,
  OrderUpdate,
  ProductFilters,
  STORED_ORDER,
  UpdateCart,
} from ".";
import { ReducerFunctions } from "../../config/helper";
import {
  Addresses,
  Regions,
  Products,
  GetProfomaDoc,
  UpdateProfomaDoc,
  OrderGetComments,
} from "./Action";
import _ from "lodash";
import { LOGOUT, LOGOUT_MAINTAIN, MAINTAINANCE } from "../../../config/helper";
export const PRODUCT_FILTERS = "PRODUCT_FILTERS";
export const get_addresses_reducer = ReducerFunctions(Addresses, {});
export const order_repeat_reducer = ReducerFunctions(OrderRepeat, {});
export const order_history_reducer = ReducerFunctions(OrderHistory, {});
export const order_add_comments_reducer = ReducerFunctions(
  OrderAddComments,
  {}
);
export const order_get_comments_reducer = ReducerFunctions(
  OrderGetComments,
  {}
);

export const get_prod_filters_reducer = ReducerFunctions(ProductFilters, {});
export const update_order_reducer = ReducerFunctions(OrderUpdate, {});
export const get_orders_reducer = (state = {}, action) => {
  let data = Array.isArray(action?.payload)
    ? [...action?.payload]
    : { ...action?.payload };
  switch (action?.type) {
    case GetOrders.REQUEST:
      return {
        ...state,
        data: {},
        loading: true,
      };
    case GetOrders.SUCCESS: {
      let orders = [];
      const checkOrderStatus = (item) => {
        if (item.Augru !== "Z92" && item.SoNumber && item.OrderStatus === "C") {
          return "Completed";
        } else if (item.Augru !== "Z92" && item.SoNumber) {
          return "Confirmed";
        } else if (item.Augru === "Z92") {
          return "Cancelled";
        } else return "To Be Confirmed";
      };
      data?.new_orders?.forEach((ele) => {
        let obj = {
          SKU: ele.Matnr,
          "Unit Price": ele.Netpr,
          Pattern: ele.Maktx,
          Quantity: parseInt(ele.Kwmeng),
          Amount: parseFloat(ele.Netpr) * parseInt(ele.Kwmeng),
          rim: ele["ZStandardrim"],
          li: ele["ZLoadindex"],
          sr: ele["ZSpeedrating"],
          lr: ele["ZLoadrating"],
          Size: ele["ZSize1"],
          appliction: ele["Application"],
          category: ele["ZSeason"],
          total_fill: ele["Fill"],
        };
        let idx = orders.findIndex((itm) => itm.order_number === ele.OrderId);
        if (idx > -1) {
          orders[idx].line_items.push(obj);
          orders[idx].total_quantity = Array.isArray(orders?.[idx]?.line_items)
            ? _.sumBy(orders?.[idx]?.line_items, "Quantity")
            : obj.Quantity
            ? obj.Quantity
            : 0;
          orders[idx].total_price = Array.isArray(orders?.[idx]?.line_items)
            ? _.sumBy(orders?.[idx]?.line_items, "Amount")
            : obj.Amount
            ? obj.Amount
            : 0;
        } else {
          orders.push({
            order_number: ele.OrderId,
            date: moment(ele.QuotationDate, "YYYYMMDD").format("YYYY/MM/DD"),
            order_type: "FD",
            so_number: ele.SoNumber,
            customer_number: ele.CustomerId,
            po_number: ele.Bstnk,
            order_status: checkOrderStatus(ele),
            order_sales_nav: ele,
            line_items: [obj],
            delivery_address: `${ele["Street"]}, ${ele["City1"]}, ${ele["Country"]}, ${ele["PostCode1"]}`,
            total_quantity: obj.Quantity ? obj.Quantity : 0,
            total_price: obj.Amount ? obj.Amount : 0,
          });
        }
      });
      if (Array.isArray(data?.orders?.orders))
        data.orders.orders = [...data.orders.orders, ...orders].sort((a, b) => {
          if (a.date === b.date) {
            return b.order_number - a.order_number;
          }
          return new Date(b.date) - new Date(a.date);
        });
      else if (orders?.length > 0)
        data.orders.orders = orders.sort((a, b) => {
          if (a.date === b.date) {
            return b.order_number - a.order_number;
          }
          return new Date(b.date) - new Date(a.date);
        });
      return {
        data,
        loading: false,
        success: true,
      };
    }
    case GetOrders.FAILED:
      return {
        ...state,
        data,
        loading: false,
        success: false,
      };
    case GetOrders.RESET:
      return {
        loading: false,
      };

    default:
      return state;
  }
};
export const get_order_reducer = (state = {}, action) => {
  let data = Array.isArray(action?.payload)
    ? [...action?.payload]
    : { ...action?.payload };
  switch (action?.type) {
    case GetOrder.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GetOrder.SUCCESS: {
      return {
        data,
        loading: false,
        success: true,
      };
    }
    case GetOrder.CHANGED: {
      let data1 = JSON.parse(JSON.stringify({ ...state.data }));
      let line_items = data1?.line_items ? data1?.line_items : [];
      let idx = line_items.findIndex((ele) => ele.id === action.line_item.id);
      if (action.fromRow) {
        line_items[idx] = action.line_item;
      } else {
        if (idx > -1) {
          line_items[idx].Quantity = action.line_item.quantity;
          line_items[idx].Amount = parseFloat(
            parseFloat(action.line_item.quantity) *
              parseFloat(action.line_item.unit_price)
          ).toFixed(1);
        } else {
          action.line_item.SKU = action.line_item.sku;
          action.line_item.Pattern = action.line_item.pattern;
          action.line_item.Size = action.line_item.size;
          action.line_item["Unit Price"] = action.line_item.unit_price;
          action.line_item.Quantity = action.line_item.quantity;
          action.line_item.Amount = parseFloat(
            parseFloat(action.line_item.quantity) *
              parseFloat(action.line_item.unit_price)
          ).toFixed(1);
          console.log(action.line_item);
          line_items.push(action.line_item);
        }
      }
      data1.total_price = _.sumBy(line_items, (ele) => parseFloat(ele.Amount));
      data1.total_quantity = _.sumBy(line_items, (ele) =>
        parseInt(ele.Quantity)
      );
      data1.line_items = line_items;
      return {
        ...state,
        data: data1,
      };
    }
    case GetOrder.FAILED:
      return {
        ...state,
        data,
        loading: false,
        success: false,
      };
    case GetOrder.RESET:
      return {
        loading: false,
      };

    default:
      return state;
  }
};
export const get_regions_reducer = ReducerFunctions(Regions, {});
export const get_products_reducer = (state = {}, action) => {
  let data = Array.isArray(action?.payload)
    ? [...action?.payload]
    : typeof action?.payload === "string"
    ? action?.payload
    : { ...action?.payload };
  switch (action?.type) {
    case Products.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PRODUCT_FILTERS: {
      let prods = state.dataCP;
      if (Array.isArray(prods)) {
        const criteria = action.payload;
        const matchingProducts = prods.filter((product) => {
          return Object.keys(criteria).every((key) => {
            return criteria[key]?.includes(product[key]);
          });
        });
        state.data.products = matchingProducts;
      }
      return {
        ...state,
        loading: false,
      };
    }
    case Products.SUCCESS: {
      const filters = {};
      const keys = [
        "brand",
        "pattern",
        "season",
        "application",
        "sr",
        "lr",
        "rim",
        "size",
        "li",
      ];
      keys.forEach((ele) => {
        filters[ele] = [];
      });

      keys.forEach((ele) => {
        data.products.forEach((itm) => {
          if (!filters[ele]?.find((e) => e === itm[ele]))
            filters[ele].push(itm[ele]);
        });
      });
      if (filters["pattern"]) {
        localStorage.setItem("patterns", JSON.stringify(filters["pattern"]));
      }
      return {
        ...state,
        data,
        loading: false,
        success: true,
      };
    }
    case Products.FAILED:
      return {
        ...state,
        data,
        loading: false,
        success: false,
      };
    case Products.RESET:
      return {
        loading: false,
      };

    case Products.CHANGED: {
      if (action.isQuantity && state?.data?.products?.length > 0) {
        let prods = state?.data?.products;
        prods.forEach((ele) => {
          ele.quantity = 0;
        });
        state.data.products = prods;
      }
      return {
        ...state,
        loading: false,
      };
    }
    case LOGOUT:
      return {
        logout: action.payload,
      };
    case LOGOUT_MAINTAIN:
      return {
        ...state,
        logout: action.payload,
      };
    case MAINTAINANCE:
      return {
        ...state,
        maintainace: action.payload,
      };
    default:
      return state;
  }
};
export const get_profoma_doc_reducer = ReducerFunctions(GetProfomaDoc, {});
export const update_profoma_doc_reducer = ReducerFunctions(
  UpdateProfomaDoc,
  {}
);
export const add_to_cart_reducer = ReducerFunctions(AddToCart, {});
export const create_order_reducer = ReducerFunctions(CreateOrder, {});
export const update_cart_reducer = ReducerFunctions(UpdateCart, {});
export const delete_from_cart_reducer = ReducerFunctions(
  DeleteItemFromCart,
  {}
);
export const get_cart_reducer = ReducerFunctions(GetCart, {});
export const storedOrder_reducer = (
  state = {
    order_type: "",
    fd_region_id: "",
    shipping_address_id: "",
  },
  action
) => {
  switch (action.type) {
    case STORED_ORDER:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
